/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */

import React from 'react';
import moment from 'moment';
import {Glyphicon, Button, Div} from 'react-bootstrap';

export default class JobOverviewItem extends React.Component {
  constructor(props) {
    super(props);
    this.backgroundStyleForStatus = this.backgroundStyleForStatus.bind(this);
  }

  backgroundStyleForStatus(js) {
        if (!js || !js.status) {
            return "jobOverviewItemWarn jobOverviewBase";
        }

        switch (js.status.st || "") {
            case "OK" : return "jobOverviewItemOk jobOverviewBase" ;
            case "WARN" : return "jobOverviewItemWarn jobOverviewBase" ;
            case "ERROR" : return "jobOverviewItemError jobOverviewBase" ;
            default: return "jobOverviewItemWarn jobOverviewBase";
        }
  }

  render() {
    let job = this.props.job ;
    let statusChange = (job.state && job.state.status && job.state.status.ts) ? moment.utc(job.state.status.ts, 'YYYYMMDDHHmmss').local().format("MM/DD/YYYY HH:mm") : "N/A";
    let jobNum = job.jobnum || "N/A";
    let hs = this.backgroundStyleForStatus(job.state);

    return (
        <div className={hs} key={job.jobId}>
            <h3 readOnly disabled>{job.name}</h3>
            <small readOnly>Job Number : {jobNum}</small><br />
            <small readOnly>Last Change: {statusChange}</small>
        </div>
    );

  }
}



// WEBPACK FOOTER //
// ./src/app/components/jobs/jobOverviewItem.js